
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { scaleCorrectors } from '../../projection/styles/scale-correction.mjs.js';
import { isTransformProp, isTransformOriginProp } from '../../render/html/utils/transform.mjs.js';

function isForcedMotionValue(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (isTransformProp(key) ||
        isTransformOriginProp(key) ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}

export { isForcedMotionValue };
//# sourceMappingURL=is-forced-motion-value.mjs.js.map
